export const environment = {
  production: false,

  // Doddly
  apiBaseUrl: 'https://staging.api.dodd.ly',

  // Subscribly
  subscriblyRedirectURI: 'https://staging.dashboard.dodd.ly',

  // Recaptcha
  recaptchaSiteKey: '6LdcyK8rAAAAAOl17PzFixEtz6VzEmodoaFf2c2a',

  // Firebase
  firebaseConfig: {
    apiKey: 'AIzaSyDkBAu6Lh_F8tPF24pSB8EZVdzPOZQw99g',
    authDomain: 'doddly-staging-e2f29.firebaseapp.com',
    projectId: 'doddly-staging-e2f29',
    storageBucket: 'doddly-staging-e2f29.firebasestorage.app',
    messagingSenderId: '534072385878',
    appId: '1:534072385878:web:7893a6bc6883ff79cd36f7',
    measurementId: 'G-0JG90QKM45',
  },

  // Paddle
  paddleConfig: {
    token: 'test_16841b8cffe9d52b662e2c12307',
    apiKey:
      'pdl_sdbx_apikey_01k275s30p9e2c9sc87pmmbm73_0fhNnB0T9KE9SC05RDDQVC_AMY',
    customerPortal:
      'https://sandbox-customer-portal.paddle.com/cpl_01js9mxb3fmmqnhtmp9wbcbs5d',

    switchToCinchMonthlyId: 'pri_01js9nd63dzwc3j5g7k61ftgds',
    switchToCinchAnnuallyId: 'pri_01js9nehjpgc5121twpv6hy6jd',
    addExtraWorkspacesMonthlyId: 'pri_01k24yay75kv8vz66wjdh2n0dj',
    addExtraWorkspacesAnnuallyId: 'pri_01k24z4wsc2m983ma52nmsyhcr',
    addExtraChannelsMonthlyId: 'pri_01k24zpwha67g6q856r3pmdjxv',
    addExtraChannelsAnnuallyId: 'pri_01k24zqstm9ca1ev9y9zfaegmd',
  },
};
